import { Spinner } from '@components/Spinner';
import React from 'react';
import * as styled from './loading-spinner.styled';

export const LoadingSpinner: React.FC<{ size: number }> = ({ size }) => {
    return (
        <styled.Wrapper size={size}>
            <Spinner size={size} />
        </styled.Wrapper>
    );
};
